import React from "react";
import { XCircle, Home } from "lucide-react";
import { Button } from "./ui/button";

/**
 * Stripe redirects the browser here when the user clicks "Back" or closes
 * the Checkout window. Purely informational — the `payment_transactions`
 * row is left as "initiated" and will auto-expire via Stripe's own
 * `checkout.session.expired` webhook.
 */
export default function PaymentCancelView({ onNavigateHome }) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-100 flex items-center justify-center px-4">
      <div
        data-testid="payment-cancel-view"
        className="max-w-lg w-full bg-white rounded-3xl shadow-xl border border-gray-200 p-10 text-center"
      >
        <XCircle className="w-16 h-16 text-gray-400 mx-auto mb-5" />
        <h1 className="text-3xl font-bold text-[#1E3A5F] mb-2">
          Checkout cancelled
        </h1>
        <p className="text-gray-600 mb-8">
          No worries — you weren't charged. Come back whenever you're ready to
          pick a plan.
        </p>
        <Button
          onClick={onNavigateHome}
          data-testid="payment-cancel-home-btn"
          className="bg-gradient-to-r from-cyan-500 to-cyan-600 hover:from-cyan-600 hover:to-cyan-700 text-white rounded-full px-6 py-3 shadow-lg"
        >
          <Home className="w-4 h-4 mr-2" />
          Back to PriceValuator
        </Button>
      </div>
    </div>
  );
}
